(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  const sel=document.querySelector('.shop-sort'); if(!sel) return;
  const params=new URLSearchParams(location.search); const v=params.get('sort_by'); if(v) sel.value=v;
})();

  } catch(e) { console.error(e); }
})();
})();
